module.exports = __webpack_public_path__ + "static/img/personal.823819c7.png";